import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import numeral from 'numeral';
import { css } from '@bd/bdui-styles/emotion';
import { Link } from '@bd/bdcore-named-routes';
import { ActivateMapPin } from '@bd/bdcore-data/build/Map';
import { Image, GoogleMapUrl } from '@bd/bdcore-utilities';
import { colors } from '../styles';

const styles = css`
  display: flex;
  justify-content: center;
  .CommunityCard_wrapper {
    width: 100%;
    display: flex;
  }
  .CommunityCard_inner {
    width: 100%;
    display: flex;
    background-color: #FFFFFF;
    flex-direction: column;
  }
  .CommunityCard_media {
    width: 100%;
    margin: 0 25px 15px 0;
    img {
      width: 100%;
      height: auto;
    }
  }
  .CommunityCard_content {
    display: flex;
    flex-grow: 1;
    flex-direction: column;
    padding: 15px;
    h4 {
      color: ${colors.color5};
      font-weight: 700;
      font-size: 20px;
      line-height: 24px;
      margin: 0;
    }
    h5 {
      font-weight: 300;
      font-size: 15px;
      color: ${colors.color5};
    }
    .CommunityCard_priceWrapper {
      border-top: 1px solid ${colors.color3};
      border-bottom: 1px solid ${colors.color3};
      display: flex;
      justify-content: space-between;
      .CommunityCard_priceLabel {
        padding: 12px 0;
        margin: 0;
      }
      .CommunityCard_priceValue {
        padding: 10px 15px;
        background-color: ${colors.color3Light};
        font-size: 19px;
        font-weight: 400;
        margin: 0;
      }
    }
    ul {
      list-style: none;
      padding: 0;
      margin: 10px 0 10px 0;
      li {
        font-size: 14px;
        font-weight: 300;
        line-height: 1;
        margin: 0 0 5px 0;
      }
    }
    .CommunityCard_buttonWrapper {
      display: flex;
      justify-content: center;
      margin: 0 -30px -15px -30px;
      @media (min-width: 992px) {
        margin: 0 -15px -15px 0;
        justify-content: flex-end;
      }

      .CommunityCard_mapButton {
        width: 40px;
        height: 40px;
        background-color: #6C6C6C;
        background-image: url('/images/icon-map-pin-white.svg');
        background-position: center center;
        background-repeat: no-repeat;
        @media (min-width: 992px) {
          width: 40px;
          height: 40px;
        }
      }
      .CommunityCard_detailButton {
        width: 80%;
        height: 40px;
        line-height: 40px;
        text-align: center;
        background-color: ${colors.color2};
        color: #FFFFFF;
        font-weight: 700;
        font-size: 15px;
        @media (min-width: 992px) {
          width: 210px;
        }
      }
    }
  }
  @media (min-width:768px) {
    margin: 0 0 0 0;
    .CommunityCard_wrapper {
      width: 495px;
    }
    .CommunityCard_inner {
      width: 100%;
      display: flex;
      background-color: #FFFFFF;
      padding: 15px;
      flex-direction: row;
    }
    .CommunityCard_media {
      width: 140px;
      margin: 0 25px 0 0;
      img {
        width: 100%;
        height: auto;
      }
    }
    .CommunityCard_content {
      padding: 0;
    }
  }
`;

function CommunityCard({ community }) {
  return (
    <div className={styles}>
      <div className="CommunityCard_wrapper">
        <div className="CommunityCard_inner">
          <div className="CommunityCard_media">
            <Link name="community-detail" community={community}>
              <Image
                src={get(community, 'photos[0].contentUrl')}
                alt={get(community, 'name')}
                width={475}
                height={315}
                exact
              />
            </Link>
          </div>
          <div className="CommunityCard_content">
            <h4>{get(community, 'name')}</h4>
            <h5>{get(community, 'address.addressLocality')}, {get(community, 'address.addressRegion')}</h5>
            <div className="CommunityCard_priceWrapper">
              <span className="CommunityCard_priceLabel">Priced From</span>
              <span className="CommunityCard_priceValue">{numeral(get(community, 'priceLow')).format('$0,0')}</span>
            </div>
            <ul>
              {
                get(community, 'schools[0].district') &&
                <li>{get(community, 'schools[0].district')}</li>
              }
              {
                get(community, 'sqftLow') &&
                get(community, 'sqftHight') &&
                <li>
                  {numeral(get(community, 'sqftLow')).format('0,0')}
                  {' - '}
                  {numeral(get(community, 'sqftLow')).format('0,0')}
                  {' '} SQ FT
                </li>
              }
            </ul>
            <div className="CommunityCard_buttonWrapper">
              <ActivateMapPin itemId={get(community, '_id')}>
                <div className="CommunityCard_mapButton d-lg-block d-none" />
              </ActivateMapPin>
              <a href={GoogleMapUrl(community)} target="_blank" rel="noopener noreferrer">
                <div className="CommunityCard_mapButton d-lg-none d-block" />
              </a>
              <Link name="community-detail" community={community} className="CommunityCard_detailButton">Visit Community</Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

CommunityCard.propTypes = {
  community: PropTypes.object.isRequired,
};

export default CommunityCard;



// WEBPACK FOOTER //
// ./src/components/CommunityCard.js